<h1 mat-dialog-title class="text-center pm-dialog-title">{{'Language.PaymentMeansText' | translate}}</h1>
<div mat-dialog-content class="contentt">
    <div class="">
        <div class="row m-0">
            <div class="col-md-4">
                <label class="f-label"> Currency </label>
                <mat-form-field class="full-width" appearance="outline">

                    <input type="text" placeholder="" matInput [formControl]="myControlCurrency" [value]=""
                        [matAutocomplete]="autocurrency" [(ngModel)]="this.local_data.docCurrency">
                    <mat-autocomplete #autocurrency="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptionsCurrency | async" [value]="option.code"
                            (onSelectionChange)="OnOptionSelectedCurrency(option)">
                            {{option.code}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="ip-section pm-section">
            <mat-tab-group style="min-height: 0px !important" mat-stretch-tabs="false" mat-align-tabs="center"
                [selectedIndex]="selectedTabIndex">
                <mat-tab label="{{'Language.Check' | translate}}"
                    [disabled]="this.getFormDisable && this.local_data.paymentChecks.length==0">
                    <div class="mt-3">
                        <div class="row m-0">
                            <!-- <div class="col-md-4">
                                <label class="f-label"> Currency </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <mat-select>
                                      <mat-option></mat-option>
                                    </mat-select>
                                  </mat-form-field>                                  
                            </div> -->
                            <!-- <div class="col-md-4">
                                <label class="f-label"> {{'Language.CurrencyText' | translate}} </label>
                                <mat-form-field class="full-width" appearance="outline">
                
                                    <input type="text" placeholder="" matInput [formControl]="myControlCurrency" [value]=""
                                        [matAutocomplete]="autocurrency" [(ngModel)]="this.local_data.docCurrency" [disabled]="this.getFormDisable">
                                    <mat-autocomplete #autocurrency="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredOptionsCurrency | async" [value]="option.code"
                                            (onSelectionChange)="OnOptionSelectedCurrency(option)">
                                            {{option.code}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div> -->
                            <div class="col-md-4">
                                <label class="f-label">{{'Language.AccountNameText' | translate}} </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput [(ngModel)]="this.local_data.checkAccount"
                                        [disabled]="this.getFormDisable"
                                        (click)="!getFormDisable && onOpenDropDown(1,0)">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                        (click)="onOpenDropDown(1,0)" [class.disabled-icon]="getFormDisable">
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <label class="f-label">{{'Language.AccountNameText' | translate}} </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput readonly [(ngModel)]="this.local_data.checkAccountName"
                                        [disabled]="this.getFormDisable"
                                        (click)="!getFormDisable && onOpenDropDown(1,0)">

                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-md-12">
                                <div class="tabledesign">
                                    <table mat-table [dataSource]="this.local_data.paymentChecks">

                                        <!-- ============ Due Date Column ============ -->
                                        <ng-container matColumnDef="dueDate">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.DueDateText' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let row">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input matInput [matDatepicker]="picker" name="taxDate"
                                                        [(ngModel)]="row.dueDate" [disabled]="this.getFormDisable">
                                                    <mat-datepicker-toggle matIconSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <!-- ============ Country Column ============ -->
                                        <ng-container matColumnDef="country">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.CountryText' |
                                                translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline"
                                                    matTooltip="{{row.countryName}}" matTooltipPosition="below">
                                                    <input type="text" matInput [(ngModel)]="row.countryName"
                                                        [disabled]="this.getFormDisable"
                                                        (click)="onOpenDropDown('country',i)">
                                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                        (click)="onOpenDropDown('country',i)"
                                                        [class.disabled-icon]="getFormDisable">
                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Deposit To Column ============ -->
                                        <!-- <ng-container matColumnDef="depositTo">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.DepositTo' | translate}} </th>
                                            <td mat-cell *matCellDef="let row">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline"
                                                    matTooltip="{{row.itemDescription}}" matTooltipPosition="below" >
                                                    <input type="text"  matInput [disabled]="this.getFormDisable">

                                                </mat-form-field>
                                            </td>
                                        </ng-container> -->

                                        <!-- ============ Bank Name Column ============ -->
                                        <ng-container matColumnDef="bankName">
                                            <th mat-header-cell *matHeaderCellDef>{{'Language.BankNameText' |
                                                translate}}</th>
                                            <td mat-cell *matCellDef="let row;let index=index;">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline"
                                                    matTooltip="{{row.bankName}}" matTooltipPosition="below">
                                                    <input type="text" matInput [disabled]="this.getFormDisable"
                                                        [(ngModel)]="row.bankName"
                                                        (click)="onOpenDropDown('banks',index)">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>

                                        <!-- ============ Bank Branch Column ============ -->
                                        <ng-container matColumnDef="bankBranch">
                                            <th mat-header-cell *matHeaderCellDef>{{'Language.BankBranchText' |
                                                translate}}</th>
                                            <td mat-cell *matCellDef="let row">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline"
                                                    matTooltip="{{row.branch}}" matTooltipPosition="below">
                                                    <input type="text" [(ngModel)]="row.branch" matInput
                                                        [disabled]="this.getFormDisable">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <!-- ============ Account Name Column ============ -->
                                        <ng-container matColumnDef="accountName">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.AccountNameText' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let row;let i=index">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput matTooltip="{{row.accounttNum}}"
                                                        (click)="onOpenDropDown('checkAccount',i)"
                                                        matTooltipPosition="below" [disabled]="this.getFormDisable"
                                                        [(ngModel)]="row.accounttNum">
                                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                        (click)="onOpenDropDown('checkAccount',i)"
                                                        [class.disabled-icon]="getFormDisable">
                                                </mat-form-field>
                                            </td>
                                        </ng-container>





                                        <!-- ============ Cheque No. Column ============ -->
                                        <ng-container matColumnDef="chequeNo">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.ChequeNo' | translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline">
                                                    <input type="text" matInput [disabled]="this.getFormDisable"
                                                        [(ngModel)]="row.checkNumber" matTooltip="{{row.checkNumber}}"
                                                        matTooltipPosition="below">

                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="amount">
                                            <th mat-header-cell *matHeaderCellDef> {{'Language.AmountText' | translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <mat-form-field class="w-160 field-bottom-0" appearance="outline"
                                                    matTooltipPosition="below">
                                                    <input type="number" matInput matTooltip="{{row.checkSum}}"
                                                        [(ngModel)]="row.checkSum" [disabled]="this.getFormDisable"
                                                        (input)="onChangeAmount()">
                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="delete">
                                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                                {{'Language.ActionText' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let row;let i=index" class="text-center">
                                                <i-feather class="t-icon popinter pointer" name="trash-2"
                                                    (click)="deleteCheck(i)" [disabled]="this.getFormDisable">
                                                </i-feather>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row class="tablecard" *matRowDef="let row; columns: displayedColumns;">
                                        </tr>
                                    </table>
                                </div>
                                <div class="">
                                    <button mat-stroked-button color="primary" (click)="addCheck()"
                                        [disabled]="this.getFormDisable">{{'Language.AddCheck' | translate}}</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Bank Transfer" [disabled]="this.getFormDisable && this.local_data.transferSum==0">
                    <!-- <div class="bt-section mt-3">
                        <div class="btsec-1"> -->
                    <div class="col-md-12 mt-3" style="display:flex">

                        <!-- <div class="row m-0">
                                <div class="col-md-6">
                                <label class="f-label"> Currency </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <mat-select>
                                      <mat-option></mat-option>
                                    </mat-select>
                                  </mat-form-field>                                  
                            </div>  -->
                        <!-- <div class="col-md-4">
                                <label class="f-label"> {{'Language.CurrencyText' | translate}} </label>
                                <mat-form-field class="full-width" appearance="outline">
                
                                    <input type="text" placeholder="" matInput [formControl]="myControlCurrency" [value]=""
                                        [matAutocomplete]="autocurrency" [disabled]="this.getFormDisable" [(ngModel)]="this.local_data.docCurrency">
                                    <mat-autocomplete #autocurrency="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredOptionsCurrency | async" [value]="option.code"
                                            (onSelectionChange)="OnOptionSelectedCurrency(option)">
                                            {{option.code}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div> -->
                        <div class="col-md-4">
                            <label class="f-label"> {{'Language.AccountNameText' | translate}} </label>
                            <mat-form-field class="full-width" (click)="onOpenDropDown('accountBank',0)"
                                appearance="outline">
                                <input type="text" [disabled]="this.getFormDisable" matInput
                                    [(ngModel)]="this.local_data.transferAccount">
                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <label class="f-label"> {{'Language.AccountNameText' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" readonly [disabled]="this.getFormDisable" matInput
                                    [(ngModel)]="this.local_data.transferAccountName"
                                    (click)="onOpenDropDown('accountBank',0)">

                            </mat-form-field>
                        </div>


                    </div>
                    <div class="col-md-12 mt-3" style="display:flex">
                        <div class="col-md-4">
                            <label class="f-label"> {{'Language.TransferDate' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input matInput [matDatepicker]="picker" [disabled]="this.getFormDisable"
                                    placeholder="dd/mm/yyyy" [(ngModel)]="this.local_data.transferDate">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <label class="f-label"> {{'Language.TotalText' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="number" [disabled]="this.getFormDisable" matInput
                                    [(ngModel)]="this.local_data.transferSum" (input)="onChangeAmount()">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <label class="f-label"> {{'Language.ReferenceText' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
                                <input type="text" [disabled]="this.getFormDisable" matInput
                                    [(ngModel)]="this.local_data.transferReference">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Cash" [disabled]="this.getFormDisable && this.local_data.cashSum==0">
                    <div class="mt-3">

                        <div class="row m-0">
                            <!-- <div class="col-md-6">
                                <label class="f-label"> Currency </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <mat-select>
                                      <mat-option></mat-option>
                                    </mat-select>
                                  </mat-form-field>                                  
                            </div> -->
                            <!-- <div class="col-md-4">
                                <label class="f-label"> Currency </label>
                                <mat-form-field class="full-width" appearance="outline">
                
                                    <input type="text" placeholder="" matInput [formControl]="myControlCurrency" [value]=""
                                        [matAutocomplete]="autocurrency" [disabled]="this.getFormDisable" [(ngModel)]="this.local_data.docCurrency">
                                    <mat-autocomplete #autocurrency="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredOptionsCurrency | async" [value]="option.code"
                                            (onSelectionChange)="OnOptionSelectedCurrency(option)">
                                            {{option.code}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div> -->
                            <div class="col-md-4">
                                <label class="f-label"> Account Code </label>
                                <mat-form-field class="full-width" appearance="outline"
                                    (click)="onOpenDropDown('cashAccount',0)">
                                    <input type="text" matInput [disabled]="this.getFormDisable"
                                        [(ngModel)]="this.local_data.cashAccount">
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <label class="f-label"> Account Name </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput readonly [disabled]="this.getFormDisable"
                                        [(ngModel)]="this.local_data.cashAccountName"
                                        (click)="onOpenDropDown('cashAccount',0)">

                                </mat-form-field>
                            </div>
                            <div class="col-md-offset-md6 col-md-4">
                                <label class="f-label"> Total </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="number" [disabled]="this.getFormDisable" matInput
                                        [(ngModel)]="this.local_data.cashSum" (input)="onChangeAmount()">
                                </mat-form-field>
                            </div>

                        </div>

                    </div>
                </mat-tab>
                <mat-tab label="{{'Language.CreditCard' | translate}}"
                    [disabled]="this.getFormDisable && this.local_data.paymentCreditCards.length==0">
                    <div class="mt-3">
                        <!-- <div class="col-md-4">
                            <label class="f-label"> {{'Language.CurrencyText' | translate}} </label>
                            <mat-form-field class="full-width" appearance="outline">
            
                                <input type="text" placeholder="" matInput [formControl]="myControlCurrency" [value]=""
                                    [matAutocomplete]="autocurrency" [disabled]="this.getFormDisable" [(ngModel)]="this.local_data.docCurrency">
                                <mat-autocomplete #autocurrency="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptionsCurrency | async" [value]="option.code"
                                        (onSelectionChange)="OnOptionSelectedCurrency(option)">
                                        {{option.code}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div> -->
                        <!-- <mat-accordion class="example-headers-align" multi> -->
                        <div *ngFor="let credit of this.local_data.paymentCreditCards;let i =index">
                            <!-- <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            {{credit.creditCard}}
                                        </mat-panel-title>
                                        <mat-panel-description class="text-end me-3" (click)="$event.stopPropagation()">
                                          <button (click)="deleteCard(i)">  <i-feather class="t-icon pointer" name="trash-2"></i-feather></button>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header> -->
                            <div class="row mt-3">
                                <!-- <div class="col-md-4">
                                            <label class="f-label"> Currency </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <mat-select>
                                                    <mat-option></mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div> -->
                                <!-- <div class="col-md-4">
                                            <label class="f-label"> Account Name </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput readonly >
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                            </mat-form-field>
                                        </div> -->
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.CreditCardNameText' | translate}} </label>
                                    <mat-form-field class="full-width" (click)="onOpenDropDown('creditcard',0)"
                                        appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.creditCardName">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.AccountNameText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput readonly [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.creditAcct">

                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.CreditCardNo' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.creditCardNumber">
                                        <!-- <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" (click)="callApi()"> -->
                                    </mat-form-field>
                                </div>

                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.ValidUntil' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [matDatepicker]="picker1" placeholder="dd/mm/yyyy"
                                            [(ngModel)]="credit.cardValidUntil">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label">{{'Language.IDNoText' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.ownerIdNum">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.TelephoneNoText' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.ownerPhone">
                                    </mat-form-field>
                                </div>
                                <!-- <div class="col-md-4">
                                            <label class="f-label"> {{'Language.PaymentMethod' | translate}} </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="number" matInput [disabled]="this.getFormDisable" [(ngModel)]="credit.paymentMethodCode">
                                            </mat-form-field>
                                        </div> -->
                                <div class="col-md-4">
                                    <label class="f-label">{{'Language.AmountDue' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [(ngModel)]="credit.creditSum"
                                            [disabled]="this.getFormDisable">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.NoofPayments' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.numOfPayments">
                                    </mat-form-field>
                                </div>
                                <!-- <div class="col-md-4">
                                            <label class="f-label"> {{'Language.FirstPartialPayment' | translate}} </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="number" matInput  [disabled]="this.getFormDisable" [(ngModel)]="credit.firstPaymentSum">
                                            </mat-form-field>
                                        </div> -->
                                <!-- <div class="col-md-4">
                                            <label class="f-label"> {{'Language.EachAddPayment' | translate}}</label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="number" matInput  [disabled]="this.getFormDisable" [(ngModel)]="credit.additionalPaymentSum">
                                            </mat-form-field>
                                        </div> -->
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.VoucherNo' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.voucherNum">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.TransactionType' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" [disabled]="this.getFormDisable" matInput>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <label class="f-label"> {{'Language.TotalText' | translate}} </label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="number" matInput [disabled]="this.getFormDisable"
                                            [(ngModel)]="credit.creditSum" (input)="onChangeAmount()">
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>
                        <!-- <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Credit Card Name 2
                                        </mat-panel-title>
                                        <mat-panel-description class="text-end me-3" (click)="$event.stopPropagation()">
                                            <i-feather class="t-icon pointer" name="trash-2"></i-feather>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div class="row mt-3">
                                        <div class="col-md-4">
                                            <label class="f-label"> Currency </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <mat-select>
                                                    <mat-option></mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Account Name </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput readonly>
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Credit Card Name </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Credit Card No. </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Valid Until </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> ID No. </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Telephone No. </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Payment Method </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Amount Due </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> No. of Payments </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> First Partial Payment </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Each Add. Payment </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Voucher No. </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="f-label"> Transaction Type </label>
                                            <mat-form-field class="full-width" appearance="outline">
                                                <input type="text" matInput>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-expansion-panel> -->
                        <!-- </mat-accordion> -->
                        <!-- <div class="">
                                <button mat-stroked-button color="primary" (click)="addCredit()">+ Add New Card</button>
                            </div> -->

                    </div>
                </mat-tab>
            </mat-tab-group>

            <div class="col-md-12 all-amt mt-0" style="display:flex">
                <div class="amt">
                    <div class="col-md-12">
                        {{'Language.OverallAmount' | translate}}
                    </div>
                    <div class="col-md-10 text-end">
                        <mat-form-field class="full-width" appearance="outline">
                            <input type="text" matInput [disabled]="this.getFormDisable"
                                [(ngModel)]="this.local_data.docTotal">
                        </mat-form-field>
                    </div>
                </div>
                <div class="amt">
                    <div class="col-md-12">
                        {{'Language.PaidAmount' | translate}}
                    </div>
                    <div class="col-md-10 ml-2">
                        <mat-form-field class="full-width" appearance="outline">
                            <input type="text" matInput [disabled]="this.getFormDisable"
                                [(ngModel)]="this.local_data.totalPayment">
                        </mat-form-field>
                    </div>
                </div>


                <div class="amt">
                    <div class="col-md-12">
                        {{'Language.BalanceDue' | translate}}
                    </div>
                    <div class="col-md-10 text-end ml-2">
                        <mat-form-field class="full-width" appearance="outline">
                            <input type="text" matInput [disabled]="this.getFormDisable"
                                [(ngModel)]="this.local_data.balance_due">
                        </mat-form-field>
                    </div>
                </div>
                <div class="amt">
                    <div class="col-md-12 ml-2">
                        {{'Language.BankCharges' | translate}}
                    </div>
                    <div class="col-md-10 text-end">
                        <mat-form-field class="full-width" appearance="outline">
                            <input type="text" matInput [disabled]="this.getFormDisable"
                                [(ngModel)]="this.local_data.bankChargeAmount">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close (click)="cancel()">{{'Language.CancelText' | translate}}</button>
    <button mat-raised-button color="primary" (click)="save()">{{txt | translate}}</button>
</div>